import styles from "./styles.module.scss";
interface IPDFComponentProps {
  fileUrl: string;
  fileName?: string;
  isPreview?: boolean;
}

const PDFComponent = ({ fileUrl, fileName, isPreview }: IPDFComponentProps) => {
  const name = fileName || fileUrl?.split("/")?.pop();
  const previewPDF = () => {
    window.open(fileUrl, "_blank", "rel=noopener noreferrer");
  };
  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
  };
  return (
    <div onClick={previewPDF} className={styles["preview_container"]}>
      <img alt="pdf" src={"/assets/images/svg/pdf.svg"} />
      <div className={styles["text"]}>
        <p>{name}</p>
        <a
          target="_blank"
          download={name}
          href={fileUrl}
          onClick={handleDownloadClick}
          rel="noreferrer"></a>
      </div>
    </div>
  );
};

export default PDFComponent;
